import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "임금대장", -1)
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "임금명세서.pdf", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "임금명세서(개별).zip", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "임금대장(고객용).xlsx", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "임금대장(회계처리용).xlsx", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "비과세전후비교.pdf", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fontNotoSans500" }, "비과세전후비교(1년치)", -1)
const _hoisted_10 = { class: "empWageCalcTbTr" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "d-flex align-center justify-content-center" }
const _hoisted_14 = {
  class: "text-center",
  style: {"flex":"1"}
}
const _hoisted_15 = {
  key: 0,
  style: {"background-color":"rgb(255, 230, 86)","border-radius":"10px"}
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "text-right" }
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = {
  class: "text-right",
  style: {"font-weight":"700"}
}
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = { class: "text-right" }
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "text-right" }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "text-right" }
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = { class: "text-right" }
const _hoisted_43 = { class: "text-right" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = {
  class: "text-right",
  style: {"font-weight":"700"}
}
const _hoisted_47 = { class: "text-right" }
const _hoisted_48 = { class: "text-right" }
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = { class: "text-right" }
const _hoisted_51 = { class: "text-right" }
const _hoisted_52 = { class: "text-right" }
const _hoisted_53 = { class: "text-right" }
const _hoisted_54 = {
  class: "text-right",
  style: {"font-weight":"700"}
}

import AdminLoadingAction from '../../../components/admin/layout/AdminLoadingAction.vue'
import WageLedgerPayDate from "../../../components/admin/wage/WageLedgerPayDate.vue";
import WageLedgerManualModal from "../../../components/admin/wage/WageLedgerManualModal.vue";
import WageBeforeAfter from "../../../components/admin/wage/WageBeforeAfter.vue";
import WageBeforeAfterYearly from "../../../components/admin/wage/WageBeforeAfterYearly.vue";
import FormatMonth from '../../../components/admin/common/datePicker/FormatMonth.vue'
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import axios from "axios";
import { useStore } from 'vuex';
import { mdiMagnify } from "@mdi/js";
import WageDirectPay from '../../../components/admin/wage/WageDirectPay.vue';
import AligoSMS from '../../../components/api/AligoSMS.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WageLedger',
  setup(__props) {

const store = useStore();

const loading = ref(false);
// eslint-disable-next-line
const wageList = ref([] as any[]);
// eslint-disable-next-line
const code = ref(store.state.AdminSisulCode) as any;
// eslint-disable-next-line
const bizGubun = ref(store.state.AdminBizGubun) as any;
// eslint-disable-next-line
const sisulName = ref(store.state.AdminSisulName) as any;

const search = ref("");
const date = ref(store.state.AdminYYMM);
const headerCateList = ref([
  {
    title: "사원구분",
    align: "center",
    children: [
      { title: "순번", key: "index", align: "center", sortable: false },
      { title: "이름", key: "empName", align: "center", sortable: false },
      { title: "직종", key: "empJob", align: "center", sortable: false },
    ],
  },
  {
    title: "임금구성",
    align: "center",
    children: [
      { title: "기본급", key: "base", align: "center", sortable: false },
      { title: "연장수당", key: "overtime", align: "center", sortable: false },
      { title: "야간수당", key: "night", align: "center", sortable: false },
      { title: "휴일수당", key: "holiday", align: "center", sortable: false },
      { title: "연차수당", key: "dayOffPay", align: "center", sortable: false },
      { title: "장기근속", key: "longTerm", align: "center", sortable: false },
      { title: "선임수당", key: "sunim", align: "center", sortable: false },
      { title: "상여금", key: "bonus", align: "center", sortable: false },
      { title: "교육비", key: "eduPay", align: "center", sortable: false },
      { title: "보존수당", key: "bojon", align: "center", sortable: false },
      { title: "기타수당", key: "etc", align: "center", sortable: false },
      { title: "당직수당", key: "dang", align: "center", sortable: false },
      { title: "중식대", key: "lunch", align: "center", sortable: false },
      { title: "차량비", key: "car", align: "center", sortable: false },
      { title: "양육비", key: "childcare", align: "center", sortable: false },
      { title: "임금합계", key: "total", align: "center", sortable: false },
    ],
  },
  {
    title: "조정내역",
    align: "center",
    children: [
      { title: "과세임금", key: "taxable", align: "center", sortable: false },
      { title: "통상임금", key: "usual", align: "center", sortable: false },
      { title: "최저임금", key: "minimum", align: "center", sortable: false },
    ],
  },
  {
    title: "근로자 공제",
    align: "center",
    children: [
      { title: "연 금", key: "", align: "center", sortable: false },
      { title: "건 강", key: "", align: "center", sortable: false },
      { title: "장 기", key: "", align: "center", sortable: false },
      { title: "고 용", key: "", align: "center", sortable: false },
      { title: "소득세", key: "", align: "center", sortable: false },
      { title: "지방세", key: "", align: "center", sortable: false },
      { title: "지원공제", key: "", align: "center", sortable: false },
      { title: "식비공제", key: "", align: "center", sortable: false },
      { title: "기타공제", key: "", align: "center", sortable: false },
      { title: "연말정산", key: "", align: "center", sortable: false },
      { title: "합 계", key: "", align: "center", sortable: false },
    ],
  },
  {
    title: "기관 공제",
    align: "center",
    children: [
      { title: "연 금", key: "", align: "center", sortable: false },
      { title: "건 강", key: "", align: "center", sortable: false },
      { title: "장 기", key: "", align: "center", sortable: false },
      { title: "고 용", key: "", align: "center", sortable: false },
      { title: "실 업", key: "", align: "center", sortable: false },
      { title: "산 재", key: "", align: "center", sortable: false },
      { title: "퇴직금", key: "", align: "center", sortable: false },
      { title: "합 계", key: "", align: "center", sortable: false },
    ],
  },
  // eslint-disable-next-line
] as any[]);

const filteredItems = computed(() => {
  if (!search.value) {
    return wageList.value;
  }
  return wageList.value.filter((item) => {
    const matchesSearch =
      (item.empName && item.empName.toLowerCase().includes(search.value.toLowerCase())) ||
      (item.empJob && item.empJob.toLowerCase().includes(search.value.toLowerCase()));
    return matchesSearch;
  });
});
watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      date.value = newValue;
      empWageCalc();
    }
  }
);
// eslint-disable-next-line
const tax = ref([] as any);
// eslint-disable-next-line
const soji = ref([] as any);

const empWageCalc = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/empWageCalc/${code.value}/${date.value}/${bizGubun.value}/${sisulName.value}`);
    const responseData = response.data;
    if (responseData) {
      wageList.value = responseData.result;
      soji.value = responseData.soji;
      tax.value = responseData.tax;
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    loading.value = false;
  }
};


const getWageExcelAdmin = async () => {
  try {
    const response = await axios.post(
      "/api/getWageExcelAdmin",
      { wageList: wageList.value },
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${wageList.value[0].sisulName}_임금대장(고객용)_${wageList.value[0].ym}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Excel 파일 다운로드 중 에러 발생:", error);
  }
};

const getWageExcelFnA = async () => {
  try {
    const response = await axios.post(
      "/api/getWageExcelFnA",
      { wageList: wageList.value },
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${wageList.value[0].sisulName}_임금대장(회계처리용)_${wageList.value[0].ym}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Excel 파일 다운로드 중 에러 발생:", error);
  }
};
const getWagePdfPreview = async () => {
  try {
    // 서버로부터 PDF 데이터를 요청
    const response = await axios.post(
      "/api/getWagePdfPreview",
      { wageList: wageList.value },
      {
        responseType: "json",
      }
    );

    // 서버로부터 받은 데이터에서 PDF Base64 문자열 추출
    const pdfBase64 = response.data.pdf;

    // Base64 문자열을 이진 데이터로 변환
    const binaryString = window.atob(pdfBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // 이진 데이터로부터 Blob 생성
    const blob = new Blob([bytes], { type: "application/pdf" });

    // Blob URL 생성
    const url = window.URL.createObjectURL(blob);

    // 새 창에서 PDF 열기
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("새 창을 열 수 없습니다. 팝업 차단 설정을 확인하세요.");
    }
  } catch (error) {
    console.error("PDF 미리보기 중 에러 발생:", error);
  }
};

const getWagePdfZip = async () => {
  try {
    const response = await axios.post(
      "/api/getWagePdfZip",
      { wageList: wageList.value },
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${wageList.value[0].sisulName}_임금명세서_${wageList.value[0].ym}.zip`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("ZIP 다운로드 중 에러 발생:", error);
  }
};

const wageDirectPayRef = ref();
const aligoSmsRef = ref();
const wageBeforeAfterRef = ref();
const wageBeforeAfterYearlyRef = ref();

const openJobTotals = () => {
  wageDirectPayRef.value?.openDialog();
};

const openSmsDialog = () => {
  aligoSmsRef.value?.openDialog(wageList.value);
  console.log(wageList.value,'wageList.value')
};

const openBeforeAfterModal = () => {
  wageBeforeAfterRef.value?.openDialog();
};

const openYearlyBeforeAfterModal = () => {
  wageBeforeAfterYearlyRef.value?.openDialog();
};

onMounted(async () => {
  await empWageCalc();
});
onUnmounted(() => {
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (loading.value)
    ? (_openBlock(), _createBlock(AdminLoadingAction, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "pa-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "rounded-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-account-cash")
                        ]),
                        _: 1
                      }),
                      _hoisted_2,
                      _createVNode(FormatMonth)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(AligoSMS, {
                        ref_key: "aligoSmsRef",
                        ref: aligoSmsRef
                      }, null, 512),
                      _createVNode(_component_v_btn, {
                        class: "btnColorDark mr-2",
                        onClick: openSmsDialog
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 임금명세서 발송 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        class: "btnColorDark mr-2",
                        onClick: openJobTotals
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 직종별 합계 ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(WageLedgerPayDate, {
                        onSuccess: _cache[0] || (_cache[0] = ($event: any) => (empWageCalc()))
                      }),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({ class: "btnColorDark" }, props), {
                            default: _withCtx(() => [
                              _createTextVNode(" 임금보고서 ▾ ")
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, { onClick: getWagePdfPreview }, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, { onClick: getWagePdfZip }, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              }),
                              (_unref(store).getters.role)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    onClick: getWageExcelAdmin
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(store).getters.role >= 7)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    onClick: getWageExcelFnA
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_list_item, { onClick: openBeforeAfterModal }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_divider, { class: "my-1" }),
                              _createVNode(_component_v_list_item, { onClick: openYearlyBeforeAfterModal }, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(_component_v_text_field, {
                        class: "inoutSearchInput",
                        style: {"background-color":"#fff","max-width":"200px","width":"auto","min-width":"200px","margin":"0 20px 0 0"},
                        modelValue: search.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                        color: "#0f7545",
                        label: "이름/직위 검색",
                        "single-line": "",
                        clearable: "",
                        "append-inner-icon": _unref(mdiMagnify),
                        flat: "",
                        "hide-details": "auto",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue", "append-inner-icon"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      "no-data-text": "데이터가 존재하지 않습니다.",
                      "fixed-header": "",
                      density: "compact",
                      scrollable: "",
                      headers: headerCateList.value,
                      items: filteredItems.value,
                      search: search.value,
                      "item-value": "name",
                      class: "nonTbFooter empWageCalcTb adminDataTb",
                      "items-per-page": -1,
                      "items-per-page-options": [
              // { value: 50, title: '50' },
              // { value: 100, title: '100' },
              // { value: 200, title: '200' }
              { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
            ]
                    }, {
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", _hoisted_10, [
                          _createElementVNode("td", _hoisted_11, _toDisplayString(index + 1 || 0), 1),
                          _createElementVNode("td", _hoisted_12, [
                            (item.ym === item.empOutDate)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  color: "dark",
                                  style: {"padding":"4px","height":"20px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("퇴")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (item.ym === item.empInDate)
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 1,
                                  color: "dark",
                                  style: {"padding":"4px","height":"20px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("입")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.empName || 0), 1)
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.empJob || 0), 1),
                            (item.ew_manual === '1')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                  _createVNode(WageLedgerManualModal, {
                                    onSuccess: _cache[2] || (_cache[2] = ($event: any) => (empWageCalc())),
                                    item: item,
                                    soji: soji.value,
                                    tax: tax.value
                                  }, null, 8, ["item", "soji", "tax"])
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                  _createVNode(WageLedgerManualModal, {
                                    onSuccess: _cache[3] || (_cache[3] = ($event: any) => (empWageCalc())),
                                    item: item,
                                    soji: soji.value,
                                    tax: tax.value
                                  }, null, 8, ["item", "soji", "tax"])
                                ]))
                          ]),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(item.base || 0), 1),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(item.overtime || 0), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(item.night || 0), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(item.holiday || 0), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(item.dayOffPay || 0), 1),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(item.longTerm || 0), 1),
                          _createElementVNode("td", _hoisted_23, _toDisplayString(item.sunim || 0), 1),
                          _createElementVNode("td", _hoisted_24, _toDisplayString(item.bonus || 0), 1),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(item.eduPay || 0), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(item.bojon || 0), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(item.etc || 0), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(item.dang || 0), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(item.lunch || 0), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(item.car || 0), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(item.childcare || 0), 1),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(item.total || 0), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(item.taxable || 0), 1),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(item.usual || 0), 1),
                          _createElementVNode("td", _hoisted_35, _toDisplayString(item.minimum || 0), 1),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(item.l_yeon || 0), 1),
                          _createElementVNode("td", _hoisted_37, _toDisplayString(item.l_gun || 0), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(item.l_jang || 0), 1),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(item.l_go || 0), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(item.l_so || 0), 1),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(item.l_ji || 0), 1),
                          _createElementVNode("td", _hoisted_42, _toDisplayString(item.l_jiwon || 0), 1),
                          _createElementVNode("td", _hoisted_43, _toDisplayString(item.l_sik || 0), 1),
                          _createElementVNode("td", _hoisted_44, _toDisplayString(item.l_etc || 0), 1),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(item.l_yearEnd || 0), 1),
                          _createElementVNode("td", _hoisted_46, _toDisplayString(item.l_total || 0), 1),
                          _createElementVNode("td", _hoisted_47, _toDisplayString(item.c_yeon || 0), 1),
                          _createElementVNode("td", _hoisted_48, _toDisplayString(item.c_gun || 0), 1),
                          _createElementVNode("td", _hoisted_49, _toDisplayString(item.c_jang || 0), 1),
                          _createElementVNode("td", _hoisted_50, _toDisplayString(item.c_go || 0), 1),
                          _createElementVNode("td", _hoisted_51, _toDisplayString(item.c_sil || 0), 1),
                          _createElementVNode("td", _hoisted_52, _toDisplayString(item.c_san || 0), 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(item.c_out || 0), 1),
                          _createElementVNode("td", _hoisted_54, _toDisplayString(item.c_total || 0), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items", "search", "items-per-page-options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(WageDirectPay, {
          ref_key: "wageDirectPayRef",
          ref: wageDirectPayRef
        }, null, 512),
        _createVNode(WageBeforeAfter, {
          ref_key: "wageBeforeAfterRef",
          ref: wageBeforeAfterRef,
          wageList: wageList.value,
          tax: tax.value
        }, null, 8, ["wageList", "tax"]),
        _createVNode(WageBeforeAfterYearly, {
          ref_key: "wageBeforeAfterYearlyRef",
          ref: wageBeforeAfterYearlyRef
        }, null, 512)
      ], 64))
}
}

})